module.exports = __webpack_public_path__ + "media/device_images/iphone-player-profile-ffs-09cfd8a9.jpg";